/* eslint-disable */

/**
 * Copyright (c) Grab
 * Grab Design Tokens Project
 * Do not edit directly
 */


export const gdsCornerRadius40 = "8px";
export const gdsCornerRadius200 = "16px";
export const gdsCornerRadius450 = "32px";
export const gdsCornerRadius700 = "64px";
export const gdsCornerRadius3xs = "2px";
export const gdsCornerRadius2xs = "4px";
export const gdsCornerRadiusXs = "8px";
export const gdsCornerRadiusS = "12px";
export const gdsCornerRadiusM = "16px";
export const gdsCornerRadiusL = "18px";
export const gdsCornerRadiusXl = "20px";
export const gdsCornerRadiusFull = "10240px";
